module.exports = __webpack_public_path__ + "img/OA.ca0b8f2c.png";